import { render, staticRenderFns } from "./trainerPrevTraining.vue?vue&type=template&id=0b8ba89a&scoped=true"
import script from "./trainerPrevTraining.vue?vue&type=script&lang=js"
export * from "./trainerPrevTraining.vue?vue&type=script&lang=js"
import style0 from "./trainerPrevTraining.vue?vue&type=style&index=0&id=0b8ba89a&prod&scoped=true&lang=css"
import style1 from "./trainerPrevTraining.vue?vue&type=style&index=1&id=0b8ba89a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ba89a",
  null
  
)

export default component.exports